import { render, staticRenderFns } from "./ComplementaryPaymentBlock.vue?vue&type=template&id=60bb6bd6&lang=pug&"
import script from "./ComplementaryPaymentBlock.vue?vue&type=script&lang=js&"
export * from "./ComplementaryPaymentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports